module.exports = __webpack_public_path__ + "img/griffons-logo-icon.84da265e.png";